import { useMemo } from "react";

/**
 * Hourglass SVG visual — represents jours de vie sacrifiés.
 * percent : 0 (intact) → 100 (vie totalement sacrifiée).
 */
export default function Hourglass({ percent = 50, label = "JOURS SACRIFIÉS", value, sub, size = 220 }) {
  const clamped = Math.max(0, Math.min(100, percent));
  const fillTop = useMemo(() => 100 - clamped, [clamped]);
  const fillBottom = clamped;

  return (
    <div className="flex flex-col items-center" data-testid="hourglass-visual">
      <svg width={size} height={size * 1.4} viewBox="0 0 200 280" className="text-[var(--ink)]">
        <defs>
          <pattern id="grain" patternUnits="userSpaceOnUse" width="4" height="4">
            <rect width="4" height="4" fill="#D92D20" />
            <rect x="0" y="0" width="2" height="2" fill="#B42318" opacity="0.4" />
          </pattern>
          <clipPath id="topGlass">
            <polygon points="30,20 170,20 105,140 95,140" />
          </clipPath>
          <clipPath id="bottomGlass">
            <polygon points="95,140 105,140 170,260 30,260" />
          </clipPath>
        </defs>

        {/* Frame top */}
        <rect x="20" y="14" width="160" height="6" fill="currentColor" />
        <rect x="20" y="260" width="160" height="6" fill="currentColor" />

        {/* Glass outline */}
        <polygon points="30,20 170,20 105,140 95,140" fill="none" stroke="currentColor" strokeWidth="1.4" />
        <polygon points="95,140 105,140 170,260 30,260" fill="none" stroke="currentColor" strokeWidth="1.4" />

        {/* Sand top */}
        <g clipPath="url(#topGlass)">
          <rect x="0" y={20 + (fillBottom * 1.2)} width="200" height="200" fill="url(#grain)" />
        </g>

        {/* Falling stream */}
        {clamped > 0 && clamped < 100 && (
          <line x1="100" y1="142" x2="100" y2="160" stroke="#D92D20" strokeWidth="1.5" />
        )}

        {/* Sand bottom */}
        <g clipPath="url(#bottomGlass)">
          <rect x="0" y={260 - (fillBottom * 1.2)} width="200" height="200" fill="url(#grain)" />
        </g>
      </svg>

      <div className="mt-3 text-center">
        {value !== undefined && (
          <div className="text-5xl sm:text-6xl font-light tracking-tighter font-sans tabular-nums" data-testid="hourglass-value">
            {value}
          </div>
        )}
        <div className="label-mono mt-1">{label}</div>
        {sub && <div className="text-xs text-[var(--muted)] mt-1 font-mono">{sub}</div>}
      </div>
    </div>
  );
}
